// extracted by mini-css-extract-plugin
export default {"diceRow":"diceRow-sgWJitpy"};